module.exports = __webpack_public_path__ + "static/media/2start.4bd7255a.png";